import apiClient from "./http";

export const getDevta = () => apiClient.get("/vastutools/devta");

export const getAyadi = () => apiClient.get("/vastutools/ayadi");

export const getNumerology = () => apiClient.get("/vastutools/numerology");

export const getAstroVastu = () => apiClient.get("/vastutools/astro-vastu");

export const getLalKitab = () => apiClient.get("/vastutools/lal-kitab");
